import type { Action, ThunkAction } from '@reduxjs/toolkit'
import { configureStore } from '@reduxjs/toolkit'
import type { ReactNode } from 'react'
import { Provider } from 'react-redux'

import cachedViewsReducer from './features/cachedViews/cachedViewsSlice'
import commentsReducer from './features/comments/commentsSlice'
import dimensionFiltersReducer from './features/dimensionFilters/dimensionFiltersSlice'
import globalLauncherReducer from './features/globalLauncher/globalLauncherSlice'
import miscReducer from './features/misc/miscSlice'
import viewGroupForestReducer from './features/viewGroupForest/viewGroupForestSlice'
import viewQueryResultsReducer from './features/viewQueryResults/viewQueryResultsSlice'
import viewsReducer from './features/views/viewsSlice'

const store = configureStore({
  reducer: {
    views: viewsReducer,
    viewGroupForest: viewGroupForestReducer,
    cachedViews: cachedViewsReducer,
    comments: commentsReducer,
    viewQueryResults: viewQueryResultsReducer,
    dimensionFilters: dimensionFiltersReducer,
    misc: miscReducer,
    globalLauncher: globalLauncherReducer,
  },
})

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
export type AppThunk<ThunkReturnType = void> = ThunkAction<ThunkReturnType, RootState, unknown, Action>

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function ReduxProvider({ children }: { children: ReactNode }) {
  return <Provider store={store}>{children}</Provider>
}
